import axios from "../axiosInstance";
import { FetchChapterDetailsResponse } from "./types";

export const fetchChapterDetails =
  async (): Promise<FetchChapterDetailsResponse> => {
    const response = await axios.get<FetchChapterDetailsResponse>(
      "/api/private/chapter-details",
    );
    return response.data;
  };
